import { FC, useMemo } from 'react';
import { Card } from '@/components/ui/card';
import { SectionHeadingGroup } from '@/components/ui/section-heading-group';
import { strings } from '@/constants/strings';
import { useCurrentCalls } from '@/hooks/use-current-calls';
import { toSorted } from '@/utils/array/to-sorted';
import { compareCallsByTimeDesc } from '@/utils/calls/compare-calls-by-time-desc';
import { CallList } from './components/calls-list';

export const CallsView: FC = () => {
  const { data: Calls, isFetching: isFetchingResponses } = useCurrentCalls();

  const orderedCalls = useMemo(
    () => toSorted(Calls, compareCallsByTimeDesc),
    [Calls],
  );

  return (
    <>
      {/* TODO extract row layout into reusable component i.e. shared with unit creation steps */}
      <div className="flex flex-row flex-wrap gap-8">
        <div className="w-min min-w-60 max-w-96 flex-grow">
          {/* TODO: use SectionContainerLayout */}
          <SectionHeadingGroup
            subtitle={strings.calls.subtitle}
            title={strings.calls.title}
          />
        </div>
        <Card className="w-min min-w-[32rem] p-6">
          <div className="pb-7 pl-6 pt-1">
            <div className="text-base font-semibold">Last 30 days</div>
          </div>
          <CallList calls={orderedCalls} loading={isFetchingResponses} />
        </Card>
      </div>
    </>
  );
};
